/**
 * Copyright (c) 2023, Mohamed eRrais (merrais / MeR)
 * merrais@tech2us.ma
 * https://ocr.1ai.ma, https://akademy.ma, https://digitalservices.ma, https://app.2us.ma, https://2us.ma, 
 * محمد الرايس
 * Tech2us
 * 231023 1504 : From math.akademy.ma
 * 240701 1259 : From tajwyd.akademy.ma
**/

import React,{useState, useEffect} from 'react'
import './meTree.css'
import Api, {Fetch} from '../Shared/Api'
import {Ts} from '../../config/switcher';

const TreeView = ({app, request, onChange, lang, Message=null}) => {
    const levels = (app=='Digitization') ? ['Root','Account','Campaign','Flow','Folder','Page'] : ['Root','Account','Site','Drive','File','Detail']
    const [loaded, Load] = useState(false)
    const [refreshed, Refresh] = useState('')
    const [selected, Select] = useState({entity:'', id:0, parent:0})
    const [tree, Tree]= useState([])

    useEffect(() => {
        Tree([])
        
        //alert(request)
        Api.get(request)
        .then(response => {
            setNodes(response.data)
            .then(nodes=> {
                Tree(nodes)
                Load(true)
            })
        })
        .catch(error => {
            Message && Message(error)
            //console.error(error)
        })

    }, [])

    useEffect(()=>{
        if(selected.entity.length>0 && selected.id>0) {
            Refresh(`${selected.entity}-${selected.id}`)
        }
    },[tree])

    const setNodes = (items) => {
        const nodes = []
        return new Promise(function (resolve, reject) {
            let l1, l2, l3, l4
            let n1=0, n2=0, n3=0, n4=0
            //alert(JSON.stringify(items))
            items?.forEach(item => {
                if(n1!==item[`${levels[1]}Id`]){
                    nodes.push({id:item[`${levels[1]}Id`], text:setText(item[`${levels[1]}Id`],item[`${levels[1]}`]), title:item[`${levels[1]}_`], nodes:[]})
                    n1=item[`${levels[1]}Id`]
                    l1=nodes[nodes.length-1]
                    n2=0
                }

                if(n2!==item[`${levels[2]}Id`]){
                    l1.nodes.push({id:item[`${levels[2]}Id`], text:setText(item[`${levels[2]}Id`],item[`${levels[2]}`]), title:item[`${levels[2]}_`], nodes:[]})
                    n2=item[`${levels[2]}Id`]
                    l2=l1.nodes[l1.nodes.length-1]
                    n3=0
                }
                
                if(n3!==item[`${levels[3]}Id`]){
                    l2.nodes.push({id:item[`${levels[3]}Id`], text: setText(item[`${levels[3]}Id`],item[`${levels[3]}`]), title:item[`${levels[3]}_`], nodes:[]})
                    n3=item[`${levels[3]}Id`]
                    l3 = l2.nodes[l2.nodes.length-1]
                    n4=0
                }
                
                if(n4!==item[`${levels[4]}Id`]){
                    l3.nodes.push({id:item[`${levels[4]}Id`], text:setText(item[`${levels[4]}Id`],item[`${levels[4]}`]), title:item[`${levels[4]}_`], nodes:[]})
                    n4=item[`${levels[4]}Id`]
                    l4=l3.nodes[l3.nodes.length-1]
                }

                l4.nodes.push({id:item[`${levels[5]}Id`], text:setText(item[`${levels[5]}Id`],item[`${levels[5]}`]), title:item[`${levels[5]}_`]})
            })
            resolve(nodes)
        })
    }
    
    const setText = (id,name) => {
        return id ? `${id} - ${name}` : '+'
    }

    const onCollapse = (item) => {
        const ul = item.querySelector('ul')
        if (ul) {
            for (let i = 1; i < 5; i++) {
                if (item.classList.contains(`Node${i}`)) {

                    const nodes = item.querySelectorAll(`.Node${i+1}`)
                    nodes.forEach(function(node) {
                        if (node.classList.contains('collapsed')) {
                            node.classList.remove('collapsed');
    
                        } else {
                            node.classList.add('collapsed');
                        }
                    })

                }
            }            
        }

        if(item && !item.classList.contains('selected')) {
            const lis = document.getElementById('meTree').querySelectorAll('li')
            lis.forEach(li => {
                if (li.classList.contains('selected')) {
                    li.classList.remove('selected')
                }
            })
            item.classList.add('selected')  
        }

    }  
    
    useEffect(()=>{
        // Etat(selected.entity); alert(selected.entity)
        onChange && onChange(selected)
    }, [selected])
     
    const onNode = (e, parent=0) => {

        if(e) {
            onCollapse(e.target.parentElement)
            
            let ss = e.target.id.split('-')
            if(ss?.length===2) {
                Select({entity:ss[0], id:ss[1], parent:parent})                
            }

            //alert(`${e.target.id} => ${ss[0]} ${ss[1]} ${e.target.innerText} parent ${parent}`)
            if(e.target.innerText==='+'){
                if (e.shiftKey) {
                    const data = {
                        Entity: ss[0],
                        ParentId: parent, // parentElement
                        Name:ss[0]
                    }
                    Fetch('/data', data, e.target.parentElement)
                    .then(item => {
                        e.target.innerText=ss[0]
                    })
                }
            }
        }
    }

    const onRefresh = (e) => {
        Refresh('')
        Load(false)
    }

    useEffect(()=>{
        if(refreshed.length>0) {
            Message(`Refresh ${refreshed}`)

            const uls = document.getElementById('meTree')?.querySelectorAll('ul')
            uls?.forEach(ul => {            
                const lis = ul?.querySelectorAll('li')
                lis?.forEach(li => {
                    const label=li.querySelector('.label')?.id //; alert(`${label} === ${refreshed}`)
                    if (label===refreshed) {
                        //alert(label)

                        var pl=li?.parentElement
                        while(pl?.tagName!=='DIV'){
                            if(pl?.tagName==='LI'){
                                if (pl.classList.contains('collapsed')) {
                                    //alert(pl.id)
                                    pl.classList.remove('collapsed')
                                }
                            }
                            pl=pl?.parentElement
                            
                            if(pl?.tagName==='DIV'){
                                if (!li.classList.contains('selected')) {
                                    li.classList.add('selected')   
                                }                                    
                            }
                        }
                        //console.log(li.parentElement) ;alert(label)
                        
                        //li.classList.add('selected')                        
                    }
                })
            })
        }   
    },[refreshed])
 
    return (
        loaded ? 
        <div id="treeContainer">   
        <span className="label0" id={`${levels[1]}-0`} onClick={e => onNode(e)}>{app}</span>
        <ul id="meTree">
        { tree.map(level1 => (
                <li className="Node1" value={level1.id} id={`Node1-${level1.id}`}>
                    <span className="label" title={level1.title} onClick={(e) => onNode(e)} id={`${levels[2]}-${level1.id}`}>{level1.text}</span>
                
                <ul>
                { level1.nodes.map(level2 => (
                    <li className='Node2 collapsed' id={`Node2-${level2.id}`}>
                        <span className="label" title={level2.title} onClick={(e) => onNode(e,level1.id)} id={`${levels[3]}-${level2.id}`}>{level2.text}</span>

                    <ul>
                    { level2.nodes.map(level3 => (
                    <li className='Node3 collapsed' id={`Node3-${level3.id}`}>
                        <span className="label" title={level3.title} onClick={(e) => onNode(e,level2.id)} id={`${levels[4]}-${level3.id}`}>{level3.text}</span>

                    <ul>
                    { level3.nodes.map(level4 => (
                        <li className='Node4 collapsed' id={`Node4-${level4.id}`}>
                            <span className="label" title={level4.title} onClick={(e) => onNode(e,level3.id)} id={`${levels[5]}-${level4.id}`}>{level4.text}</span>
                        <ul>
                        { level4.nodes.map(page => (
                            <li className='Node5 collapsed' id={`Node5-${page.id}`} >
                                <span className="label"  title={page.title} onClick={(e) => onNode(e,level4.id)} id={`${levels[6]}-${page.id}`}>{page.text}</span>
                            </li>
                            ))
                        }                
                        </ul>
                        </li>
                        ))
                    }                
                    </ul>
                    </li>
                ))
                }                
                    </ul>
                    </li>
                ))
                }                
                </ul>
                </li>
            ))
        }
    </ul> 
    </div> 

    : <div>Nodes are loading...</div> 
    )
}

export default TreeView